import './resources.css'

const FirstWebinarResource = () => {
    return (

        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/infection-control/")}> Infection Control & Prevention (CFSPH)  </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/diseaseinfo/")}> Animal diseases (CFSPH) </li>
            <li onClick={() => window.open("https://www.aphis.usda.gov/aphis/ourfocus/animalhealth/nvap/CT_aast")}>USDA APHIS NVAP Training Modules for Accreditation Renewal </li>
            {/*Nested List */}
            <li style = {{'marginLeft': '40px', 'listStyleType': 'circle'}}
                onClick={()=> window.open("https://nvap.aphis.usda.gov/BCD/story_html5.html")}> Module 4: Preventing Disease Introduction and Spread </li>
        </ul>
    )
}

export default FirstWebinarResource;